/*
 * @Author: 孙培国
 * @Date: 2024-08-15 09:32:29
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-01-21 15:00:34
 * @FilePath: \new-adminproject-frontend-h5\src\utils\request.js
 */
import axios from 'axios'
import { Toast, Dialog } from 'vant'
// 根据环境不同引入不同api地址
import { baseUrl } from '@/config'
import router from '@/router'
import { Tips } from '@/utils/index'
// create an axios instance

console.log('baseApi', baseUrl)

const service = axios.create({
  baseURL: baseUrl,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // 等待时间
})

// request拦截器 request interceptor
service.interceptors.request.use(
  config => {
    // 不传递默认开启loading
    if (!config.hideloading) {
      // loading
      Tips.loading(config.message)
    }
    if (localStorage.getItem('token')) {
      config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    }
    config.baseURL = config.baseURL + '/'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug

    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    Toast.clear()
    const res = response.data

    console.log('resresresresres', res)

    if (res.code && res.code !== 200 && res.code !== 1010) {
      console.log('res', res.message)
      Tips.error(res.message)
      return Promise.reject(res)
    } else {
      if (res.code !== 0) {
        return Promise.resolve(res)
      } else {
        Tips.error(res.message)
        return Promise.reject(res)
      }
    }
  },
  error => {
    Toast.clear()
    if (error.response.code === 401) {
      Dialog({ message: '登录过期，请重新登录' }).then(() => {
        localStorage.removeItem('token')
        router.replace('/login')
      })
    } else {
      Tips.error(error.response.data.message)
    }
    return Promise.reject(error)
  }
)
export default service
